import { useTranslation } from 'react-i18next'
import * as z from 'zod'

import { useCommonSchema } from './commonSchema'

export const useUpdateLegalNameSchema = () => {
  const { firstName, lastName } = useCommonSchema()
  const { t } = useTranslation()

  // Regex to allow only letters A-Z (uppercase and lowercase) and a single word
  const singleLatinWord = /^[A-Za-z]+$/

  const updateLegalNameSchema = z.object({
    firstName: firstName
      .refine((val) => !val.includes(' '), {
        message: t('api:validationErrors.onlyOneWord', {
          field: t('form:fields.firstName').toLowerCase(),
        }),
      })
      .refine((val) => singleLatinWord.test(val), {
        message: t('api:validationErrors.onlyLatinLetters'),
      }),
    lastName: lastName
      .refine((val) => !val.includes(' '), {
        message: t('api:validationErrors.onlyOneWord', {
          field: t('form:fields.lastName').toLowerCase(),
        }),
      })
      .refine((val) => singleLatinWord.test(val), {
        message: t('api:validationErrors.onlyLatinLetters'),
      }),
  })

  return updateLegalNameSchema
}

export type IUpdateLegalNameSchema = z.infer<
  ReturnType<typeof useUpdateLegalNameSchema>
>
